//Specify your data here
export enum SessionDataType {
    BookingData,
}

export function getLocalStorageSessionManager(sgId: string): LocalStorageSessionManager {
    return new LocalStorageSessionManager(sgId);
}

export class LocalStorageSessionManager {
    private readonly sessionDataName: string;
    private readonly sessionTimestampName: string;
    private readonly expiryTime: number = 20;

    constructor(sgId: string) {
        this.sessionDataName = `session_data_name_${sgId}`;
        this.sessionTimestampName = `current_timestamp_${sgId}`;
    }

    setTimestampOnLoad() {
        let savedTimestamp = localStorage.getItem(this.sessionTimestampName);
        if (!savedTimestamp || this.isNewSession(savedTimestamp)) {
            this.setTimestamp();
            localStorage.setItem(this.sessionDataName, "");
        }
    }

    private isNewSession(savedTimestamp: string) {
        return Date.now() - parseInt(savedTimestamp) >= this.expiryTime * 1000 * 60;
    }

    getData<T>(type: SessionDataType) {
        try {
            const data = this.getSession();

            if (data == null) {
                return null;
            }

            const object = data[type];

            if (!object) {
                return null;
            }

            const parsed = JSON.parse(object);

            const typed = parsed as T;

            return typed;
        } catch (e) {
            console.log(e);

            return null;
        }
    }

    setData<T>(type: SessionDataType, data: T) {
        try {
            let session = this.getSession();

            if (session == null) {
                session = {};
            }

            const serializedData = JSON.stringify(data);

            session[type] = serializedData;

            const serializedSession = JSON.stringify(session);

            localStorage.setItem(this.sessionDataName, serializedSession);
        } catch (e) {
            console.log(e);
        }
    }

    private setTimestamp() {
        localStorage.setItem(this.sessionTimestampName, Date.now().toString());
    }

    private getSession() {
        const serializedState = localStorage.getItem(this.sessionDataName);

        if (serializedState === "") {
            return null;
        }

        const data = JSON.parse(serializedState);
        this.setTimestamp();
        return data;
    }
}
